import { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useApiClient } from "./userApi";

const UserServiceContext = createContext();

const UserService = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);
  const apiClient = useApiClient();
  const [errors, setErrors] = useState(null);
  const [cities, setCities] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [clientAddressData, setClientAddress] = useState({});
  const [packagesData, setPackagesData] = useState({
    amountPayed: 0,
    amountByInvoices: 0,
    amountBalance: 0,
    amountTotalPent: 0,
    amountUnPayedInvoices: 0,
    countDeliveryOrders: 0,
  });
  const [deliveryOrders, setDeliveryOrders] = useState([]);
  const [newNotification, setNewNotification] = useState({});
  const [subUsers, setSubUsers] = useState([]);
  const [userTypes, setUserTypes] = useState([]);

  const [userFavoriteClients, setUserFavoriteClients] = useState([]);
  const [deliveryOrderTypes, setDeliveryOrderTypes] = useState([]);
  const [peymentMethods, setPeymentMethods] = useState([]);
  const [deliveryMethods, setDeliveryMethods] = useState([]);
  const [packageTypes, setPackageTypes] = useState([]);

  const logout = async () => {
    try {
      setLoading(true);
      await apiClient.get("/Users/LogOut");
      setLoading(false);
      Cookies.remove("Token");
      navigate("/auth-signin");
    } catch (errors) {
      Cookies.remove("Token");
      navigate("/auth-signin");
    }
  };

  const home = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/Home");
      const { data } = response;
      //console.log(data);
      if (data.success) {
        const user = data.user;
        const {
          amountPayed,
          amountByInvoices,
          amountBalance,
          amountTotalPent,
          amountUnPayedInvoices,
          countDeliveryOrders,
        } = data;

        setPackagesData({
          amountPayed,
          amountByInvoices,
          amountBalance,
          amountTotalPent,
          amountUnPayedInvoices,
          countDeliveryOrders,
        });
        //console.log(user);
        setUser(user);
      }
      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const changePassword = async (data) => {
    setLoading(true);
    try {
      const response = await apiClient.post("/Users/ChangePassword", data);

      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const changeProfile = async (data) => {
    setLoading(true);
    try {
      const response = await apiClient.post("/Users/ChangeProfile", data);

      setLoading(false);

      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const smsCode = async (data) => {
    try {
      setLoading(true);
      const response = await apiClient.post("/Users/SmsPinRequest", data);
      setLoading(false);

      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const changePhone = async (data) => {
    try {
      setLoading(true);
      const response = await apiClient.post("/Users/ChangePhone", data);
      setLoading(false);

      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  // #region Addresses

  const getAddresses = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/Home/GetAddresses");
      setLoading(false);

      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const addressAdd = async (formData) => {
    try {
      setLoading(true);
      const response = await apiClient.post("/Home/AddressAdd", formData);
      setLoading(false);
      const { data } = response;

      return data;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const addressDeactivate = async (id) => {
    try {
      setLoading(true);
      const response = await apiClient.get(`/Home/AddressDeactivate/${id}`);
      setLoading(false);

      const { data } = response;

      return data;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const contactAdd = async (formData) => {
    try {
      setLoading(true);
      const response = await apiClient.post("/Home/ContactAdd", formData);
      setLoading(false);
      const { data } = response;

      return data;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const contactUpdate = async (formData) => {
    try {
      setLoading(true);
      const response = await apiClient.post("/Home/ContactUpdate", formData);
      setLoading(false);
      const { data } = response;

      return data;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const contactDeactivate = async (id) => {
    try {
      setLoading(true);
      const response = await apiClient.get(`/Home/ContactDeactivate/${id}`);
      setLoading(false);

      const { data } = response;

      return data;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const getClientAddress = async (id) => {
    try {
      setLoading(true);
      const response = await apiClient.get(`/Home/GetAddresses/${id}`);
      setLoading(false);
      const { data } = response;
      const { clientAddress } = data;
      setClientAddress(clientAddress[0]);
      return data;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  // #endregion

  // #region DeliveryOrders


  //download delivery order sticker
  const downloadSticker = async (url) => {
    try {

      setLoading(true);

      await apiClient.get("DeliveryOrders/GetSticker" + url, {
        responseType: "blob", // important for binary files like PDFs
      })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });

          const fileURL = window.URL.createObjectURL(blob);
          window.open(fileURL, "_blank");
        })
        .catch((error) => {
          setErrors(error);
        });

      setLoading(false);

    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };


  const getDeliveryOrders = async (formData) => {
    try {
      setLoading(true);
      const response = await apiClient.post(
        "/Home/GetDeliveryOrders",
        formData
      );
      setLoading(false);
      //console.log(response);
      const { deliveryOrders } = response.data;
      setDeliveryOrders(deliveryOrders);
      //console.log(data);

      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };
  //#endregion

  // #region Notifications
  const getNotifications = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/Home/GetNotifications");
      setLoading(false);
      const { data } = response;
      if (data.success) {
        const { notifications } = data;
        setNotifications(notifications);
      }
      //console.log(data);
      return data;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const getNotification = async (id) => {
    try {
      setLoading(true);
      const response = await apiClient.get(`/Home/GetNotification/${id}`);
      setLoading(false);
      const { data } = response;
      if (data.success) {
        console.log(data);
        const { notification } = data;
        console.log(notification);
        setNewNotification(notification);
      }
      return data;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const notificationsRead = async (data) => {
    try {
      setLoading(true);
      const response = await apiClient.post(
        "/Home/NotificationsMarkAsRead",
        data
      );
      setLoading(false);

      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const notificationDeactivate = async (data) => {
    try {
      setLoading(true);
      const response = await apiClient.post(
        "/Home/NotificationsDeactivate",
        data
      );
      setLoading(false);

      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  // #endregion

  // #region References

  const getReferences = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/Pages/GetReferences");
      setLoading(false);
      if (response && response.data) {
        const orderTypes = response.data.filter(
          (item) => item.key === "DeliveryOrderTypes"
        );
        setDeliveryOrderTypes(orderTypes);

        const peymentMethodsData = response.data.filter(
          (item) => item.key === "PaymentMethods"
        );
        setPeymentMethods(peymentMethodsData);

        const deliveryMethodsData = response.data.filter(
          (item) => item.key === "DeliveryMethods"
        );
        setDeliveryMethods(deliveryMethodsData);

        const packageTypesData = response.data.filter(
          (item) => item.key === "PackageTypes"
        );
        setPackageTypes(packageTypesData);
      }
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const getCities = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/Pages/GetReferences");
      setLoading(false);
      if (response && response.data) {
        const citiesData = response.data.filter(
          (item) => item.key === "Cities"
        );
        setCities(citiesData);
      }
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const getUserTypes = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/Pages/GetReferences");
      setLoading(false);
      if (response && response.data) {
        const userTypesData = response.data.filter(
          (item) => item.key === "ClientTypes"
        );
        setUserTypes(userTypesData);
      }
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  // #endregion

  // #region SubUsers

  const getSubUsers = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/Users/SubUsersList");
      setLoading(false);
      if (response && response.data) {
        const { users } = response.data;
        setSubUsers(users);
      }
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const createSubUser = async (formData) => {
    try {
      setLoading(true);
      const response = await apiClient.post("/Users/SubUserAdd", formData);
      setLoading(false);
      const { data } = response;

      return data;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const updateSubUser = async (formData) => {
    try {
      setLoading(true);
      const response = await apiClient.post("/Users/SubUserUpdate", formData);
      setLoading(false);
      const { data } = response;
      return data;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const deleteSubUser = async (id) => {
    try {
      setLoading(true);
      const response = await apiClient.get(`/Users/SubUserDeactivate/${id}`, {
        id,
      });
      setLoading(false);
      const { data } = response;
      return data;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };
  // #endregion

  // #region NewAddresses

  const getUserFavoriteClients = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get(
        "/UserFavorites/GetUserFavoriteClients"
      );

      if (response && response.data) {
        setUserFavoriteClients(response.data);
      }
      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const userFavoriteContactSetAsDefault = async (id) => {
    try {
      setLoading(true);
      const response = await apiClient.get(
        `/UserFavorites/ContactSetAsDefault/${id}`
      );
      // const { data } = response;
      // const { clientAddress } = data;
      // setClientAddress(clientAddress[0]);
      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const getUserFavoriteClientById = async (id) => {
    try {
      setLoading(true);
      const response = await apiClient.get(
        `/UserFavorites/GetUserFavoriteClients/${id}`
      );
      // const { data } = response;
      // const { clientAddress } = data;
      // setClientAddress(clientAddress[0]);
      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const updateUserFavoriteClient = async (formData) => {
    try {
      setLoading(true);
      const response = await apiClient.post(
        "/UserFavorites/UserFavoriteClientUpdate",
        formData
      );
      //console.log(response);
      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const addUserFavoriteClient = async (formData) => {
    try {
      setLoading(true);
      const response = await apiClient.post(
        "/UserFavorites/UserFavoriteClientAdd",
        formData
      );

      //console.log(response);
      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const deleteUserFavoriteClient = async (id) => {
    try {
      setLoading(true);
      const response = await apiClient.get(
        `/UserFavorites/UserFavoriteClientDeactivate/${id}`
      );
      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const userFavoriteContactAdd = async (formData) => {
    try {
      setLoading(true);

      const response = await apiClient.post(
        "/UserFavorites/UserFavoriteContactAdd",
        formData
      );
      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const userFavoriteContactDeactivate = async (id) => {
    try {
      setLoading(true);
      const response = await apiClient.get(
        `/UserFavorites/ContactDeactivate/${id}`
      );
      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  const userFavoriteContactUpdate = async (formData) => {
    try {
      setLoading(true);
      const response = await apiClient.post(
        "/UserFavorites/ContactUpdate",
        formData
      );
      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };
  // #endregion

  // #region NewInvoices

  const getInvoices = async (formData) => {
    try {
      setLoading(true);
      console.log("Fetching invoices with data:", formData);
      const response = await apiClient.post("/Home/GetInvoices", formData);
      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      setErrors(error);
    }
  };

  // #endregion

  return (
    <UserServiceContext.Provider
      value={{
        errors,
        user,
        loading,
        cities,
        packagesData,
        deliveryOrders,
        clientAddressData,
        notifications,
        newNotification,
        subUsers,
        userFavoriteClients,
        userTypes,
        deliveryOrderTypes,
        peymentMethods,
        deliveryMethods,
        packageTypes,
        logout,
        home,
        changePassword,
        changeProfile,
        smsCode,
        changePhone,
        getAddresses,
        getClientAddress,
        addressAdd,
        getCities,
        getUserTypes,
        addressDeactivate,
        getDeliveryOrders,
        downloadSticker,

        contactAdd,
        contactDeactivate,
        contactUpdate,
        getNotifications,
        getNotification,
        notificationsRead,
        notificationDeactivate,
        getSubUsers,
        createSubUser,
        updateSubUser,
        deleteSubUser,
        getUserFavoriteClients,
        getUserFavoriteClientById,
        addUserFavoriteClient,
        deleteUserFavoriteClient,
        userFavoriteContactAdd,
        userFavoriteContactDeactivate,
        userFavoriteContactUpdate,
        updateUserFavoriteClient,
        userFavoriteContactSetAsDefault,
        getInvoices,
        getReferences,
      }}
    >
      {children}
    </UserServiceContext.Provider>
  );
};

export { UserServiceContext, UserService };
